import rankFragmentsWithMatchesCount from 'bl/client/rankFragmentsWithMatchesCount.bl';
import rankMatchesAtStartOfFragmentsCount from 'bl/client/rankMatchesAtStartOfFragmentsCount.bl';
import rankPerfectMatch from 'bl/client/rankPerfectMatch.bl';
import rankStartOfFirstFragment from 'bl/client/rankStartOfFirstFragment.bl';
import splitText from 'bl/client/splitText.bl';
import fromAnyToLowerCase from 'utils/converters/any/fromAnyToLowerCase.util';

const calculateNameRank = (options) => {
  const text = options?.text;

  const lowered = fromAnyToLowerCase(options?.name);
  const strings = splitText(lowered);

  // let's score how well text matches user.user_name
  let rank = 0;
  rank += rankPerfectMatch({ a: text, b: lowered }) * 2;
  rank += rankFragmentsWithMatchesCount({ text, strings }) * 2;
  rank += rankMatchesAtStartOfFragmentsCount({ text, strings }) * 2;
  rank += rankStartOfFirstFragment({ text, strings }) * 2;

  return rank;
};

export default calculateNameRank;
